import statsConfig from '../../config/stats.json';
import { GET_STATS } from '../types';
import { getTimestamp } from '../../tools';

const defaultMaxTime = 30; // domyślny maksymalny czas wykonywania ćwiczenia w minutach

class Stats {
  time = 0;                 // Beżący czas trwania czynności
  timer = 0;                // interval variable
  status = false;           // started = true, not started = false
  focus = true;             // current window focus
  maxIddleTime = 0;         // liczba sekund po której w przypadku bezczynnosći czas jest pauzowany
  maxTime = defaultMaxTime; // Maksymalny czas wykonywania ćwiczenia
  iddleTime = 0;
  type = false;
  courseStats = {
    time: 0,
    courseId: 0,
    data: []
  };

  constructor () {
    setInterval(() => {
      // this.focus = document.hasFocus(); // należy również włączyć linię 42
    }, 1000);
  }

  // Rozpoczyna odliczanie czasu ćwiczenia
  // Type e.g. WORDS, NOTES, MEDIA ...
  startTime = (type) => {
    this.type = type;
    const times = statsConfig.times[type];
    if (!times) {
      console.error('Unknown exercise type: ' + type);
      return;
    }
    this.maxTime = times.max * 60;
    this.maxIddleTime = times.maxIddle;
    this.iddleTime = times.maxIddle;;
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      // if (!this.focus) return;
      if (this.maxIddleTime) {
        if (this.iddleTime < 1) return;
        --this.iddleTime;
      }
      if (this.time >= this.maxTime) return;
      this.time += 1;
    }, 1000);
    this.status = true;
  };

  stopTime = () => {
    clearInterval(this.timer);
    this.status = false;
    this.type = false;
    return this.resetTime();
  };

  getTime = () => {
    return this.time;
  };

  getType = () => {
    return this.type;
  }

  // Zatrzymuje resetuje czas i zwraca jego wartość przed resetem
  resetTime = () => {
    const time = this.time;
    this.time = 0;
    return time;
  };

  getStatus = () => {
    if (this.time >= this.maxTime) return 'max-time';
    if (this.status && !this.focus) return 'paused';
    if (this.maxIddleTime && this.iddleTime < 1) return 'iddle';
    if (this.status && this.focus) return 'running';
    return 'stopped';
  }

  action = () => {
    this.iddleTime = this.maxIddleTime;
  }

}

export default function(stats = new Stats(), action) {
  switch (action.type) {
    case GET_STATS:
      return { 
        ...stats,
        courseStats: { 
          time: getTimestamp(),
          courseId: action.courseId,
          data: action.stats
        } 
      };
    default:
      return stats;
  }
}
